import { withInstall } from '@lit-element/utils'
import ResizeBox from './src/resize-box.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtResizeBox: SFCWithInstall<typeof ResizeBox> =
  withInstall(ResizeBox)

export default LtResizeBox

export type ResizeBoxInstance = InstanceType<typeof ResizeBox>
